import { useLocalStorage } from '@maui/hooks'
import { useSelectedThreatProfileStorageKey } from './useSelectedThreatProfileStorageKey'

export const useSelectedThreatProfileStorage = () => {
  return useLocalStorage(useSelectedThreatProfileStorageKey())
}
